import { createReducer, on } from '@ngrx/store';
import * as AssetManagersActions from './asset-managers.actions';
import { initialUIState } from './asset-managers.state';

export const assetManagersReducer = createReducer(
  initialUIState,
  on(AssetManagersActions.toggleAssetManagersLoading, (state, { loading }) => ({
    ...state,
    isLoading: loading,
  })),
  on(AssetManagersActions.loadAssetManagersSuccess, (state, { assetManagers }) => ({
    ...state,
    list: assetManagers,
    isLoading: false,
  })),
  on(AssetManagersActions.loadAssetManagersFailure, (state) => ({
    ...state,
    list: [] as any[],
    isLoading: false,
  })),
);
